const X_INTENT_URL = "https://twitter.com/intent/tweet";

interface IXIntentParams {
  text: string;
  url: string;
  hashtags: string | null;
}

const parseHashtags = (hashtags: string | null): string[] =>
  (hashtags ?? "")
    .split(/[\s,]+/)
    .map((tag) => tag.replace(/^#/, ""))
    .filter(Boolean);

export const buildXIntentUrl = ({
  text,
  url,
  hashtags,
}: IXIntentParams): string => {
  const tags = parseHashtags(hashtags);
  const params = [
    `text=${encodeURIComponent(text)}`,
    `url=${encodeURIComponent(url)}`,
    ...(tags.length ? [`hashtags=${encodeURIComponent(tags.join(","))}`] : []),
  ];

  return `${X_INTENT_URL}?${params.join("&")}`;
};
